import { jsx as _jsx } from "react/jsx-runtime";
var MessageCircle = function MessageCircle(_ref) {
  var className = _ref.className,
    _ref$color = _ref.color,
    colorProp = _ref$color === void 0 ? '#181B32' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    ignoreColor = _ref.ignoreColor;
  var color = !ignoreColor ? colorProp : undefined;
  return /*#__PURE__*/_jsx("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    children: /*#__PURE__*/_jsx("path", {
      d: "M16 13a1 1 0 1 1 0-2.002A1 1 0 0 1 16 13Zm-4 0a1 1 0 1 1 0-2.002A1 1 0 0 1 12 13Zm-4 0a1 1 0 1 1 0-2.002A1 1 0 0 1 8 13Zm11.07-8.072c-2.283-2.284-5.444-3.303-8.673-2.804-4.077.636-7.457 3.92-8.22 7.987a10.016 10.016 0 0 0 .61 5.765c.099.23.129.446.09.64l-.857 4.287a.999.999 0 0 0 1.176 1.176l4.283-.856c.246-.047.485.022.644.088 1.814.767 3.808.977 5.765.611 4.067-.763 7.35-4.143 7.987-8.22.503-3.228-.52-6.389-2.804-8.674Z",
      fill: color
    })
  });
};
export default MessageCircle;